import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DepartmentComponent } from "./department/department.component";
import { SubDepartmentComponent } from "./sub-department/sub-department.component";
import { CompanyComponent } from "./company/company.component";
import { DepartmentApproversComponent } from "./department-approvers/department-approvers.component";
import { HolidayComponent } from "./holiday/holiday.component";
import { AddUserComponent } from "./add-user/add-user.component";

const routes: Routes = [
    {
        path: 'admin',
        children: [
            { path: 'departments', component: DepartmentComponent },
            { path: 'subdepartments', component: SubDepartmentComponent },
            { path: 'company', component: CompanyComponent },
            { path: 'approvers', component: DepartmentApproversComponent },
            { path: 'holiday', component: HolidayComponent },
            { path: 'add-user', component: AddUserComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdminRoutingModule {
    
}